<template>
  <div>
    <div class="dashboard page-content__header-description">
      <h1 style="flex: 1" class="page-title">Metrics</h1>
      <div class="top-actions">
        <el-input
          style="width: 30%"
          class="el-input el-input--prefix"
          placeholder="Search by name"
          prefix-icon="el-icon-search"
          v-model="searchTerm"
          clearable
        ></el-input>
      </div>
    </div>

    <div v-if="loading">
      <AnimatedSpinnerLoader />
    </div>

    <!-- The Corresponding Table -->
    <div v-if="!loading" class="vue-table">
      <vue-good-table
        :lineNumbers="true"
        :columns="fields"
        :rows="getAllPartnerMetrics"
        :pagination-options="{ enabled: true }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'user'">
            {{
              props.row.user && props.row.user.firstName
                ? props.row.user.firstName
                : "----"
            }}
            {{
              props.row.user && props.row.user.lastName
                ? props.row.user.lastName
                : "----"
            }}
          </span>

          <span v-if="props.column.field == 'api_key'">
            {{ maskValue(props.row.api_key) }}
          </span>

          <span v-if="props.column.field == 'call_count'">
            {{ props.row.call_count }}
          </span>

          <span v-if="props.column.field == 'data_size'">
            {{ props.row.data_size }}
          </span>
          <span v-if="props.column.field == 'last_used'">
            {{ formatDate(props.row.last_used) }}
          </span>
        </template>

        <template slot="pagination-bottom" slot-scope="props">
          <grey-pagination
            :total="props.total"
            :pageChanged="props.pageChanged"
            :perPageChanged="props.perPageChanged"
            @paginated-info="paginationInfo = $event"
          ></grey-pagination>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import AnimatedSpinnerLoader from "@/components/AnimatedSpinnerLoader.vue";

export default {
  name: "PartnerMetrics",
  searchdata: "",
  components: { AnimatedSpinnerLoader },
  computed: {
    getAllPartnerMetrics: {
      get() {
        return this.metrics;
      }
    }
  },
  data() {
    return {
      metrics: [],
      filteredMetrics: [],
      loading: false,
      searchTerm: "",
      fields: [
        {
          field: "user",
          label: "Name",
          sortable: "true"
        },
        {
          field: "api_key",
          label: "API_Key",
          sortable: "true"
        },
        {
          field: "call_count",
          label: "Number of calls",
          sortable: "true"
        },
        {
          field: "data_size",
          label: "Total data size (Kb)",
          sortable: "true"
        },
        {
          field: "last_used",
          label: "Last Used",
          sortable: "true"
        }
      ]
    };
  },
  methods: {
    maskValue(value) {
      const start = value.substring(0, 3);
      const end = value.substring(value.length - 3);
      return `${start}******************${end}`;
    },
    getPartnerMetrics() {
      this.loading = true;
      const HTTP = this.$httpUtils.PartnerHTTP;
      const headers = {
        "Content-Type": "application/json",
        "x-user-role": localStorage.getItem("roleType")
      };
      HTTP.get(`/admin/partner-metrics`, { headers })
        .then(res => {
          this.metrics = res.data.data;
          this.filteredMetrics = res.data.data;
          this.loading = false;
          console.log(this.metrics);
        })
        .catch(err => {
          this.loading = false;
        });
    },
    formatDate(_date) {
      return moment(_date).format("MMMM Do YYYY, h:mm:ss a");
    }
  },
  watch: {
    searchTerm: function(newVal) {
      this.metrics = this.filteredMetrics.filter(x =>
        `${x.user.firstName} ${x.user.lastName}`
          .toLowerCase()
          .includes(newVal.toLowerCase())
      );
    }
  },
  async mounted() {
    this.getPartnerMetrics();
  }
};
</script>

<style lang="scss">
h1,
h2,
p {
  margin: 0;
}
.dashboard {
  padding: 20px;
}
.page-content__header-description {
  margin: 0;
  padding-top: 0px;
  padding-bottom: 0px;
}
.page-title {
  margin: 50px 0;
  color: black;
}
.label-container {
  display: flex;
  div {
    margin-right: 10px;
  }
}

.default-label {
  border: 1px solid gray;
  border-radius: 12px;
  padding: 7px 14px;
  cursor: pointer;
  background-color: white;
  color: grey;
}
.default-label:hover {
  color: #fff;
  background-color: #337ab7;
  border-color: #2e6da4;
}
.vue-table {
  margin: 20px;
}
.top-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.content-area {
  background-color: #f5f6f8 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/partnerAccess/PartnerMetrics.vue